export default "__VITE_ASSET__B4MHQt40__"